var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mt-6"},[_c('v-row',{attrs:{"alignment":"center","justify":"center"}},[_c('v-btn',{attrs:{"color":"red"},on:{"click":_vm.checkAndDrop}},[_vm._v("\n      Drop Redis Cache\n    ")])],1),_vm._v(" "),_c('confirm',{ref:"dialog",attrs:{"persistent":true,"message":_vm.$t('message.confirmacao_drop_cache')},on:{"agree":function($event){return _vm.dropCache()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/spa/administracao/CacheManager.vue?vue&type=template&id=e19833d0&
// module id = 995
// module chunks = 28